/**
 * Suspense Wrapper Component
 * Provides consistent Suspense boundaries with error handling
 */
import { ReactElement, ReactNode, Suspense } from 'react'
import LazyLoadingFallback from '../LazyLoadingFallback'

interface SuspenseWrapperProps {
  children: ReactNode
  /** Custom fallback component */
  fallback?: ReactElement
  /** Loading message for fallback */
  loadingMessage?: string
  /** Use minimal loading style */
  minimal?: boolean
}

const SuspenseWrapper = ({
  children,
  fallback,
  loadingMessage,
  minimal = false,
}: SuspenseWrapperProps): ReactElement => {
  const defaultFallback = (
    <LazyLoadingFallback message={loadingMessage} minimal={minimal} />
  )

  return <Suspense fallback={fallback || defaultFallback}>{children}</Suspense>
}

export default SuspenseWrapper
